import { Label, Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import { StyledText } from '../../../../../web/common/components/StyledText';
import { isGetHelpSourceApp } from '../../../../../web/utils/statelessUtil';
import { RegExpPatterns, SourceApps } from '../../../../models/constants/constants';
import { FreelanceRequest } from '../../models/requestModels';
import {
  IRequestDetailsStyles,
  getTextFieldStyles,
  getGetHelpTextFieldStyles,
  getRequestDetailsClassNames,
  getRequestDetailsStyles,
} from '../../styles/requestDetailsStyles';
import { IStyledComponent } from '../../styles/themesUI';
import { getString } from '../../../../../web/utils/stringLoader';

interface IEmailFieldComponentProps {
  isEmailValid: boolean;
  isEmailEditingMode: boolean;
  isRequestDetailsEditMode: boolean;
  userEmail: string;
  isEmailFieldDisabled: boolean;
  isDarkTheme: boolean;
  sourceApp: SourceApps;
  isTeams: boolean;

  // dispatchers
  dispatchUpdateRequest: (properties: Partial<FreelanceRequest>) => void;
  dispatchUpdateIsEmailValid: (isEmailValid: boolean) => void;
}

type IThemedEmailFieldProps = IEmailFieldComponentProps & IStyledComponent<IRequestDetailsStyles>;

export class EmailField extends React.PureComponent<IThemedEmailFieldProps> {
  private requestDetailsClassNames = getRequestDetailsClassNames(
    getRequestDetailsStyles,
    { theme: this.props.theme }
  );

  public render(): React.ReactNode {
    const textFieldStyles = getTextFieldStyles({
      theme: this.props.theme,
      isInputValid: this.props.isEmailValid,
      isPhoneOrEmailField: true,
      isTeams: this.props.isTeams
    });

    if (isGetHelpSourceApp(this.props.sourceApp)) {
      return this.props.isEmailEditingMode && !this.props.isEmailFieldDisabled ? (
        <Stack horizontal>
          <Label required={!this.props.isRequestDetailsEditMode}>
            {getString('requestCreation_emailLabel')}
          </Label>
          <TextField
            id="userEmailInput"
            value={this.props.userEmail}
            type="email"
            onChange={this.onUserEmailInputChange}
            styles={getGetHelpTextFieldStyles(this.props.theme)}
            underlined
          />
        </Stack>
      ) : (
        <Stack horizontal tokens={{ childrenGap: 20 }}>
          <StyledText>{getString('requestDetails_emailLabel')}:</StyledText>
          <StyledText>{this.props.userEmail}</StyledText>
        </Stack>
      );
    }

    return this.props.isEmailEditingMode ? (
      <TextField
        label={getString('requestCreation_emailLabel')}
        styles={textFieldStyles} id='userEmailInput'
        type='email' value={this.props.userEmail}
        onChange={this.onUserEmailInputChange}
        disabled={this.props.isEmailFieldDisabled}
        required
        errorMessage={!this.props.isEmailValid && getString('requestCreation_invalidEmailMessageText')}
        onBlur={this.onBlur}
      />
    ) : (
      <div className={this.requestDetailsClassNames.propertyLine}>
        <div className={this.requestDetailsClassNames.propertyLabel}>
          {getString('requestDetails_emailLabel')}
        </div>
        <div className={this.requestDetailsClassNames.field}>
          {this.props.userEmail}
        </div>
      </div>
    );
  }

  // update when focus leaves the textbox to prevent screen reader from responding too early
  private onBlur = () => {
    // we'll allow null values since we allow phone or email during ticket creation
    this.props.dispatchUpdateIsEmailValid(!this.props.userEmail || RegExpPatterns.MultipleEmailRegex.test(this.props.userEmail));
  }

  private onUserEmailInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!!event && !!event.target) {
      event.stopPropagation();
      this.props.dispatchUpdateRequest({
        UserEmail: event.target.value,
      });
    }
  };
}
